import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';

export const SelectButton = styled.button`
  display: inline-block;
  padding: 0 12px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin: 6px 6px 6px 0;
  cursor: pointer;
  background-color: ${({ theme, selected }) => (selected ? theme.mainColor : '#fff')};
  ${getFont(0)};
  line-height: 34px;
  color: ${({ theme, selected }) => (selected ? '#fff' : theme.colors.font)};
  ${({ selected }) =>
    (selected
      ? `
      ${fontSmoothing}
      `
      : null)};

  /* stylelint-disable */
  @media (hover: hover), screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    &:hover {
      background-color: ${({ theme, selected }) => (selected ? theme.mainColor : theme.borderColor)};
    }
  }
  /* stylelint-enable */

  ${maxMediaQueries.tablet`
    display: ${({ hideMobile }) => (hideMobile ? 'none' : 'inline-block')};
  `};
`;
